export default "__VITE_PUBLIC_ASSET__54cb4d23__"